<script setup lang="ts">
import {useCallStore} from "../../../store/calls";
import {useModalStore} from "../../../store/modal";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, reactive, ref} from "vue";

const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    const formatted = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return formatted.replace(",", " at");
}

const error_message = ref(null)
const time_options = [{label: "06:00",value: "06:00"}, {label: "07:00",value: "07:00"}, {label: "08:00",value: "08:00"}, {label: "09:00",value: "09:00"}, {label: "10:00",value: "10:00"}, {label: "11:00",value: "11:00"}, {label: "12:00",value: "12:00"}, {label: "13:00",value: "13:00"}, {label: "14:00",value: "14:00"}, {label: "15:00",value: "15:00"}, {label: "16:00",value: "16:00"}, {label: "17:00",value: "17:00"}, {label: "18:00",value: "18:00"}, {label: "19:00",value: "19:00"}, {label: "20:00",value: "20:00"}, {label: "21:00",value: "21:00"}, {label: "22:00",value: "22:00"}];
const callStore = useCallStore()
const modalStore = useModalStore()
const loading = ref(false)
const call_rescheduled = ref(false)
const disabled = computed(() => loading.value || !reschedule_data.time || !reschedule_data.date)
const description = computed(() =>
    call_rescheduled.value
        ? formatDate(callStore.call.scheduled_for)
        : null
)
const heading = computed(() =>
    call_rescheduled.value
        ? "Call rescheduled."
        : "Reschedule call."
)
const reschedule_data = reactive({
    note: null,
    time: null,
    date: null
});
const rescheduleCall = async () => {
    loading.value = true
    try {
        await callStore.reschedule(modalStore.props.id, reschedule_data)
        call_rescheduled.value = true
    } catch (e) {
        error_message.value = e.response.data.message ?? "Something went wrong. Please try again."
    } finally {
        loading.value = false
    }
}
</script>

<template>
<DefaultModalBase :description :heading :icon="call_rescheduled ? 'check-all' : 'time-update'" :loading :refresh="call_rescheduled">
    <div class="call-assign-container" >
        <!--TODO: show error-->
        <brand-form-input label="Date." variant="date-outline" v-model="reschedule_data.date" v-if="!call_rescheduled" />
        <brand-form-select label="Time." :options="time_options" v-model="reschedule_data.time" v-if="!call_rescheduled"/>
        <brand-form-textarea label="Notes. (optional)" v-model="reschedule_data.note" v-if="!call_rescheduled"/>
        <brand-button @click="rescheduleCall()" :disabled v-if="!call_rescheduled">Reschedule call</brand-button>
        <brand-button @click="modalStore.close(call_rescheduled)" variant="secondary" v-else>Done</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
